import React, { useState, useEffect } from "react";
import { ToggleSwitch } from "../../components/form-inputs/inputs";

export const DESTINATION_OPTIONS = [
    { text: "GDN Export", value: "GdnExport", expectedAttribute: "gdnClientCode" },
    { text: "Product Publisher", value: "ProductPublisher", expectedAttribute: "cxHClientCode" },
];

export default function RepostOptions({ updateData, disable = [], selectedTask, disableWithUpdate, disableWithoutUpdate, setDisableResubmit }) {
    const [destinations, setDestinations] = useState(false);
    const [toDisable, setToDisable] = useState([]);
    const [shouldUpdatePostDate, setShouldUpdatePostDate] = useState(true);
    const [sendToGdsn, setSendToGdsn] = useState(selectedTask && selectedTask.context.sendToGdsn);

    useEffect(() => {
        if (shouldUpdatePostDate && disableWithUpdate) {
            return setDisableResubmit(true);
        }

        if (!shouldUpdatePostDate && disableWithoutUpdate) {
            return setDisableResubmit(true);
        }

        return setDisableResubmit(false);
    }, [shouldUpdatePostDate, disableWithUpdate, disableWithoutUpdate]);

    useEffect(() => {
        if (disable) {
            setToDisable(disable);
        }
    }, [disable]);

    useEffect(() => {
        const dest = DESTINATION_OPTIONS.reduce((opts, d) => {
            opts[d.value] = toDisable.indexOf(d.value) === -1;

            return opts;
        }, {});
        setDestinations(dest);
    }, [toDisable]);

    useEffect(() => {
        if (destinations === false) {
            return;
        }

        updateData({
            destination: Object.keys(destinations).filter((d) => destinations[d] === true),
            shouldUpdatePostDate,
            sendToGdsn,
        });
    }, [destinations, shouldUpdatePostDate, sendToGdsn]);

    if (!destinations) {
        return null;
    }

    return (
        <div className="repost-options">
            <div>
                <h2>Destinations</h2>
                {DESTINATION_OPTIONS.map((d) => {
                    return (
                        <ToggleSwitch
                            key={`toggle_${d.value}`}
                            name={d.value}
                            value={toDisable.indexOf(d.value) === -1 && destinations[d.value]}
                            label={d.text}
                            testid={`test_id_${d.value}`}
                            disabled={toDisable.indexOf(d.value) > -1}
                            updateOnChange={(name, value) => {
                                const newDestinations = { ...destinations, [name]: value };
                                setDestinations(newDestinations);
                            }}
                        />
                    );
                })}
            </div>
            <div>
                <h2>Options</h2>
                <ToggleSwitch
                    name="shouldUpdatePostDate"
                    value={shouldUpdatePostDate}
                    label="Update Post Date"
                    updateOnChange={(name, value) => {
                        setShouldUpdatePostDate(value);
                    }}
                />
                <ToggleSwitch name="sendToGdsn" value={sendToGdsn} label="Send to GDSN" updateOnChange={(name, value) => setSendToGdsn(value)} />
            </div>
        </div>
    );
}
